var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.transformed,_vm._b({tag:"component"},'component',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }